import AxiosInstance from '../../core/api/axiosinstance'
import promiseToResult from '../../core/api/promiseToResults'

export interface TransferPolicy {
  id: number
  mode: string
  allowedCountries: string[]
  createdAt: string
  updatedAt: string
}

export interface GetTransferPolicyRes {
  status: boolean
  data: TransferPolicy
}

const getTransferPolicy = () => {
  return promiseToResult(
    AxiosInstance().get<GetTransferPolicyRes>(
      '/projects/transfer-policy/settings',
    ),
  )
}

export interface PostTransferPolicyModeReq {
  mode: string
}

export interface PostTransferPolicyCountriesReq {
  countries: string[]
}

export interface PostTransferPolicyRes {
  status: boolean
  data: TransferPolicy
}

const postTransferPolicyMode = (data: PostTransferPolicyModeReq) => {
  return promiseToResult(
    AxiosInstance().post<PostTransferPolicyRes>(
      '/projects/transfer-policy/settings/mode',
      data,
    ),
  )
}

const postTransferPolicyCountries = (data: PostTransferPolicyCountriesReq) => {
  return promiseToResult(
    AxiosInstance().post<PostTransferPolicyRes>(
      '/projects/transfer-policy/settings/countries',
      data,
    ),
  )
}

export const TransferPolicyAPI = {
  getTransferPolicy,
  postTransferPolicyMode,
  postTransferPolicyCountries,
}
